import React, { useContext } from 'react'

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Icon
} from '@clientbase/clientbase-library'
import { Box, Chip, Stack, Typography } from '@mui/material'

import IconContainer from 'components/IconContainer/IconContainer'
import { getStatusComplete } from 'components/Status/Status.styles'
import { Table } from 'components/Table'

import { formatMoney } from 'utils'
import { formatDate } from 'utils/FormatDate'

import { theme } from 'styles/theme'

import { ModalInstallmentDetailContext } from '../../context'

type InstallmentsAccordionProps = {
  onOpenChargeDetail: (billingUuid: string) => void
}

const InstallmentsAccordion: React.FC<InstallmentsAccordionProps> = ({
  onOpenChargeDetail
}) => {
  const { installment } = useContext(ModalInstallmentDetailContext)

  const convertToRows = () => {
    if (!installment.billings) return []

    return installment.billings.map((billing) => ({
      uuid: billing.uuid,
      dueDate: formatDate(billing.due_date),
      paymentDate: billing.date_paid ? formatDate(billing.date_paid) : '',
      value: formatMoney(billing.amount_billed),
      valuePaid:
        billing.amount_paid !== '0.0' ? formatMoney(billing.amount_paid) : '',
      status: (
        <Box p="12px 16px">
          <Chip
            key={billing.status}
            label={getStatusComplete(billing.status, billing.due_date)?.label}
            sx={{
              backgroundColor: getStatusComplete(
                billing.status,
                billing.due_date
              )?.color,
              color: getStatusComplete(billing.status, billing.due_date)
                ?.fontColor,
              height: '25px',
              width: '160px',
              fontWeight: '600',
              [theme.breakpoints.down(508)]: {
                width: '120px'
              }
            }}
          />
        </Box>
      ),
      action: (
        <Box display="flex" justifyContent="center">
          <Icon
            icon="settings"
            sx={{
              color: theme.palette.neutral[200],
              cursor: 'pointer'
            }}
          />
        </Box>
      )
    }))
  }

  return (
    <Accordion
      defaultExpanded
      sx={{
        border: '1px solid #E8EBE8',
        borderLeft: '3px solid',
        borderLeftColor: 'primary.main',
        borderRadius: '8px !important',
        backgroundColor: '#FAFBFA',
        boxShadow: 'none',
        '&:before': { display: 'none' },
        '&.Mui-expanded': {
          margin: 0,
          backgroundColor: '#fff'
        }
      }}
    >
      <AccordionSummary aria-controls="installments-content" id="installments">
        <Stack direction="row" alignItems="center" gap={2}>
          <IconContainer icon="faCreditCard" size={2.5} />
          <Typography>Parcelas</Typography>
        </Stack>
      </AccordionSummary>
      <AccordionDetails>
        <Box maxHeight="300px" overflow="auto">
          <Table
            mobileCards
            header={[
              { id: 'dueDate', label: 'Vencimento' },
              { id: 'paymentDate', label: 'Pagamento' },
              { id: 'value', label: 'Valor' },
              { id: 'valuePaid', label: 'Valor pago' },
              { id: 'status', label: 'Status' },
              { id: 'action', label: '' }
            ]}
            hoverInRow
            rows={convertToRows()}
            select={{ useSelect: false }}
            hiddePagination
            rowAction={onOpenChargeDetail}
            hideLastRowSeparator
          />
        </Box>
      </AccordionDetails>
    </Accordion>
  )
}

export default InstallmentsAccordion
